import styled from "@emotion/styled";
import tw from "twin.macro";

interface BadgeProps {
  variant?: "default" | "warning" | "success";
}

export const Badge = styled.div<BadgeProps>`
  ${tw`inline-flex items-center justify-center rounded-full h-[24px] px-[8px] py-[4px] text-[12px] font-semibold`};

  ${({ variant }) => {
    switch (variant) {
      case "warning":
        return tw`bg-[#EE6869] text-containment-tertiary`;

      case "success":
      default:
        return tw`bg-[#DAFED0] text-text-high`;
    }
  }}
`;
